// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';
import flashMessage from '../../../utils/flashMessage';

export default class ShowView extends JQueryView {
  constructor() {
    super('.important_meetings.show');
  }

  @on({ event: 'click', selector: '.title-header-box' })
  clickToggleContent(e: any) {
    const chevronTarget = $(e.target)
      .closest('.agenda')
      .find('.icon-chevron');
    const contentTarget = $(e.target)
      .closest('.agenda')
      .find('.content');

    if (contentTarget.hasClass('d-none')) {
      chevronTarget.removeClass('ion-chevron-right');
      chevronTarget.addClass('ion-chevron-up');
      contentTarget.removeClass('d-none');
    } else {
      chevronTarget.removeClass('ion-chevron-up');
      chevronTarget.addClass('ion-chevron-right');
      contentTarget.addClass('d-none');
    }
  }

  @on({ event: 'click', selector: '.copy-share-link' })
  copyToClipboard(e: any) {
    const shareLink = e.currentTarget.dataset.link;
    if (shareLink) {
      navigator.clipboard.writeText(shareLink);
      flashMessage('共有リンクをコピーしました', 'success');
    } else {
      flashMessage(
        '共有リンクをコピーできませんでした。再度お試しください。',
        'error',
      );
    }
  }
}
